module.exports = __webpack_public_path__ + "static/kure3-a733232091f897db3fb1d7af6fc757eb.png";